/**
 * ModeratorAndQuestion — picks the moderator persona and accepts the
 * question text. Fires `onConvene()` when the user clicks Convene.
 */
import React from 'react';
import { Loader2, Send } from 'lucide-react';

export default function ModeratorAndQuestion({
  personas, moderator, onModeratorChange,
  question, onQuestionChange,
  onConvene, running, canConvene,
}) {
  return (
    <div className="mt-4 ve-card p-5">
      <h2 className="display text-lg font-bold">2. Pick the moderator + ask</h2>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <label className="text-xs uppercase tracking-[0.18em] font-bold text-slate-500">Moderator:</label>
        <select
          value={moderator}
          onChange={(e) => onModeratorChange(e.target.value)}
          data-testid="council-moderator"
          className="rounded-md border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 px-3 py-2 text-sm font-bold focus:outline-none focus:border-[#8B3FC5]"
        >
          {personas.map((p) => (
            <option key={p.id} value={p.id}>{p.english_name} — {p.role}</option>
          ))}
        </select>
      </div>
      <textarea
        value={question}
        onChange={(e) => onQuestionChange(e.target.value)}
        rows={3}
        placeholder="e.g. Should we accept a $5M strategic investment from a Singapore family office that wants a board seat?"
        data-testid="council-question"
        className="mt-3 w-full rounded-md border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:border-[#8B3FC5]"
      />
      <div className="mt-3 flex justify-end">
        <button
          onClick={onConvene}
          disabled={running || !canConvene}
          data-testid="council-convene"
          className="ve-btn-primary text-sm disabled:opacity-50"
        >
          {running ? <Loader2 size={16} className="animate-spin"/> : <Send size={16}/>}
          Convene council
        </button>
      </div>
    </div>
  );
}
